import React from 'react'
import { withRouter } from 'react-router-dom'
import { postMessage } from '../../utils'
import imgCard1 from '../../assets/img/integral_card_1.png'
import imgCard2 from '../../assets/img/integral_card_2.png'
import imgCard3 from '../../assets/img/integral_card_3.png'
import imgCard4 from '../../assets/img/integral_card_4.png'
import blue_item_1 from '../../assets/theme_blue_0/integral/integral_card_1.png'
import blue_item_2 from '../../assets/theme_blue_0/integral/integral_card_2.png'
import blue_item_3 from '../../assets/theme_blue_0/integral/integral_card_3.png'
import blue_item_4 from '../../assets/theme_blue_0/integral/integral_card_4.png'
import red_0_item_1 from '../../assets/v3/integral_grid/red_0/integral_card_1.png'
import red_0_item_2 from '../../assets/v3/integral_grid/red_0/integral_card_2.png'
import red_0_item_3 from '../../assets/v3/integral_grid/red_0/integral_card_3.png'
import red_0_item_4 from '../../assets/v3/integral_grid/red_0/integral_card_4.png'
import orange_0_item_1 from '../../assets/v3/integral_grid/orange_0/integral_card_1.png'
import orange_0_item_2 from '../../assets/v3/integral_grid/orange_0/integral_card_2.png'
import orange_0_item_3 from '../../assets/v3/integral_grid/orange_0/integral_card_3.png'
import orange_0_item_4 from '../../assets/v3/integral_grid/red_0/integral_card_4.png'

const sets = {
  imgIntegralCard1: '',
  imgIntegralCard2: '',
  imgIntegralCard3: '',
  imgIntegralCard4: '',
}

switch (process.env['REACT_APP_CHANNEL']) {
  case 'qxtj':
  case 'qxyg':
  case 'qxdg':
  case 'tjyg':
    Object.assign(sets, {
      imgIntegralCard1: blue_item_1,
      imgIntegralCard2: blue_item_2,
      imgIntegralCard3: blue_item_3,
      imgIntegralCard4: blue_item_4,
    })
    break
  case 'ytyg':
    Object.assign(sets, {
      imgIntegralCard1: orange_0_item_1,
      imgIntegralCard2: orange_0_item_2,
      imgIntegralCard3: orange_0_item_3,
      imgIntegralCard4: orange_0_item_4,
    })
    break
  case 'dyyg':
    Object.assign(sets, {
      imgIntegralCard1: red_0_item_1,
      imgIntegralCard2: red_0_item_2,
      imgIntegralCard3: red_0_item_3,
      imgIntegralCard4: red_0_item_4,
    })
    break
  // case ('xiniu'):
  // case ('xibei'):
  //   break
  default:
    Object.assign(sets, {
      imgIntegralCard1: imgCard1,
      imgIntegralCard2: imgCard2,
      imgIntegralCard3: imgCard3,
      imgIntegralCard4: imgCard4,
    })
}

@withRouter
class IntegralGrid extends React.PureComponent {

  render () {
    return <div className={'integral-grid'}>
      <div className="integral-grid__item"
           onClick={this.goToWelfare}
      >
        <img src={sets.imgIntegralCard1} alt=""/>
      </div>
      <div className="integral-grid__item"
           onClick={this.goTo.bind(this, `${window.PATH.TURNTABLE}?withHeader=1`)}
      >
        <img src={sets.imgIntegralCard2} alt=""/>
      </div>
      <div className="integral-grid__item"
           onClick={this.goTo.bind(this, window.PATH.RED_PACKET)}
      >
        <img src={sets.imgIntegralCard3} alt=""/>
      </div>
      <div className="integral-grid__item"
           onClick={this.goTo.bind(this, `${window.PATH.CARD_GAME}?withHeader=1`)}>
        <img src={sets.imgIntegralCard4} alt=""/>
      </div>
    </div>
  }

  goTo = (path, flag = true) => {
    if (flag) {
      this.props.history.push(path)
    } else {
      window.toast.info('活动暂未开始')
    }
  }
  goToWelfare = () => {
    postMessage({
      type: window.POST_TYPE.TASK_CENTER
    })
  }
}

export default IntegralGrid
